import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { translate } from 'react-i18next';

import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

import PortalLayout from '../../../layouts/PortalLayout';

import './styles/portal.css';

import config from '../../../config';


class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.dispatch = props.dispatch;
    this.loginFacebook=this.loginFacebook.bind(this);
    document.title = 'Portal - Jørgen Hanssen';
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('page.portal', {returnObjects: true});
  }

  loginFacebook(response) {
    this.props.login(response.accessToken, this.context.router.history);
  }

  render() {
    return (
      <PortalLayout>

        <h1> {this.texts.title} </h1>

        {
          this.props.io.loading ? (
            <div className="page-auth-portal-progress-container">
              <LinearProgress color="primary"/>
            </div>
          ) : (
            <FacebookLogin
            appId={config.FACEBOOK_APP_ID}
            fields='name,email,picture'
            callback={this.loginFacebook}
            render={renderProps => (
              <Button color='primary' onClick={renderProps.onClick}>
                {this.texts.button}
              </Button>
            )}
            />
          )
        }

      </PortalLayout>
    )
  }
}

Portal.contextTypes = {
   router: PropTypes.object
}

export default translate('translations')(Portal);



// WEBPACK FOOTER //
// ./src/components/pages/auth/Portal.js